<template>
  <div class="flex-col-start-start gap-2 w-100">
    <v-skeleton-loader
      v-for="i in 8"
      :key="i"
      type="image"
      width="100%"
      height="60"
    />
  </div>
</template>

<script>
export default {
  name: "Loader",
};
</script>
